/**
 * Maps Authorize.Net customer payment profile creditCard.cardType to AP_Payment.CreditCardType.description.
 */
export function dbDescriptionFromAuthorizeNetCardType(cardType) {
  if (!cardType) return null;
  const map = {
    Visa: "VISA",
    MasterCard: "Master Card",
    AmericanExpress: "American Express",
    Discover: "Discover",
    DinersClub: "Diners Club",
    JCB: "JCB",
  };
  return map[cardType] || null;
}

export function findCreditCardTypeRow(creditCardTypes, authNetCardType) {
  if (!creditCardTypes || !creditCardTypes.length) return null;
  const want = dbDescriptionFromAuthorizeNetCardType(authNetCardType);
  if (!want) return null;
  let row = creditCardTypes.find((t) => t.description === want);
  if (!row && want === "Discover") {
    row = creditCardTypes.find((t) => t.description === "Discovery");
  }
  return row || null;
}
